/**
 * 인앱 배너 워터마크 (PLAN 5-8-4장).
 *
 * 배너는 "방별로 마지막으로 본 메시지 시각"보다 앞으로 나아간 미리보기에만 뜬다.
 * 이 판단을 NotificationHost의 useEffect 안에 두면 회귀를 잡을 수 없어 순수 함수로 뺐다.
 */

export interface ConvoWatermarkEntry {
  convoId: string;
  /** 방의 마지막 메시지 시각(ms) */
  at: number;
}

export interface BannerWatermarkState {
  /** 방별로 마지막으로 본 메시지 시각 */
  watermark: Map<string, number>;
  /** 최초 스냅샷을 이미 소비했는지 */
  primed: boolean;
  /** 이번 스냅샷이 최초 스냅샷이면 배너를 띄우지 않는다 */
  isFirstSnapshot: boolean;
}

export function advanceBannerWatermark(
  previous: ReadonlyMap<string, number>,
  entries: readonly ConvoWatermarkEntry[],
  state: { primed: boolean; loaded: boolean },
): BannerWatermarkState {
  // 목록은 로그인/업데이트 직후 `{ items: [], loading: true }`로 시작한다
  // (useChat.ts의 ensureConvoList). 이 빈 스냅샷으로 프라임하면 실제 목록이
  // 도착했을 때 모든 방이 "처음 보는 방"이 되어, 이미 수신확인한 마지막 메시지가
  // 새 알림으로 다시 뜬다. 로드된 스냅샷만 최초 스냅샷 후보로 인정한다.
  if (!state.loaded) {
    return { watermark: new Map(previous), primed: state.primed, isFirstSnapshot: false };
  }

  const watermark = new Map(entries.map((entry) => [entry.convoId, entry.at]));
  return { watermark, primed: true, isFirstSnapshot: !state.primed };
}
